const initialState = [
  {
    id: 1,
    blogName: "Learn React JS",
    blogImage: "https://miro.medium.com/max/875/0*urj1fYqHHRPjgYvd.jpeg",
    authorLogo: "https://avatars.githubusercontent.com/u/73503432?v=4",
    authorName: "Learn with sumit",
    blogCategory: "Article",
    blogDate: "08 Feb, 2022",
    readTime: "11 min read",
  },
  {
    id: 2,
    blogName: "Learn Tailwind",
    blogImage:
      "https://images.unsplash.com/photo-1485988412941-77a35537dae4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YmxvZ3N8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    authorLogo: "https://avatars.githubusercontent.com/u/73503432?v=4",
    authorName: "Learn with sumit",
    blogCategory: "Programming",
    blogDate: "10 March, 2022",
    readTime: "8 min read",
  },
  {
    id: 3,
    blogName: "Learn Material UI",
    blogImage:
      "https://images.unsplash.com/photo-1516414447565-b14be0adf13e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8YmxvZ3N8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    authorLogo:
      "https://yt3.ggpht.com/ytc/AMLnZu_JuiwUKA8OSoT97avCn9xufJV0LsQFYJkMYdAq=s900-c-k-c0x00ffffff-no-rj",
    authorName: "Programming Hero",
    blogCategory: "Article",
    blogDate: "01 Jan, 2022",
    readTime: "5 min read",
  },
  {
    id: 4,
    blogName: "Why I Left Vue.js for React",
    blogImage: "https://miro.medium.com/max/875/0*5U6oqyhpaBWmF5Vb",
    authorLogo:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCV7JHhlgF4k-Rm3NQNZXp0NL6zVUI1m0cTw&usqp=CAU",
    authorName: "David Nienajadlo",
    blogCategory: "Programming",
    blogDate: "08 Feb, 2022",
    readTime: "11 min read",
  },
  {
    id: 5,
    blogName: "How to select the Node.js Version",
    blogImage: "https://miro.medium.com/max/875/1*pemVg1pGgf-tYM0CkEFqhQ.png",
    authorLogo:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCV7JHhlgF4k-Rm3NQNZXp0NL6zVUI1m0cTw&usqp=CAU",
    authorName: "Chris1993",
    blogCategory: "Programming",
    blogDate: "08 Feb, 2022",
    readTime: "11 min read",
  },
  {
    id: 6,
    blogName: "How to beacome a frontend developer",
    blogImage: "https://miro.medium.com/max/875/1*cBqseW27AvIw-7e4ls1Nxw.jpeg",
    authorLogo:
      "https://yt3.ggpht.com/ytc/AMLnZu_JuiwUKA8OSoT97avCn9xufJV0LsQFYJkMYdAq=s900-c-k-c0x00ffffff-no-rj",
    authorName: "Programming Hero",
    blogCategory: "Article",
    blogDate: "10 June, 2022",
    readTime: "14 min read",
  },
  {
    id: 7,
    blogName: "11 Mistakes to Avoid When Using React in 2022",
    blogImage: "https://miro.medium.com/max/875/1*9JaBfPmXYosuPFLF_SUppg.jpeg",
    authorLogo: "https://avatars.githubusercontent.com/u/73503432?v=4",
    authorName: "Learn with sumit",
    blogCategory: "Programming",
    blogDate: "08 Feb, 2022",
    readTime: "11 min read",
  },
  {
    id: 8,
    blogName: "10 Best React Notification Libraries in 2022",
    blogImage: "https://miro.medium.com/max/875/1*bx8YaOyxxpwSbCcbvIBgVQ.jpeg",
    authorLogo:
      "https://yt3.ggpht.com/ytc/AMLnZu_JuiwUKA8OSoT97avCn9xufJV0LsQFYJkMYdAq=s900-c-k-c0x00ffffff-no-rj",
    authorName: "Programming Hero",
    blogCategory: "Programming",
    blogDate: "08 Feb, 2022",
    readTime: "11 min read",
  },
  {
    id: 9,
    blogName:
      "6 Questions You Should Understand About the ref & reactive in Vue3",
    blogImage: "https://miro.medium.com/max/875/1*xNqPxrNYZc84Goy-IjGyNg.jpeg",
    authorLogo: "https://avatars.githubusercontent.com/u/73503432?v=4",
    authorName: "Learn with sumit",
    blogCategory: "Programming",
    blogDate: "08 Feb, 2022",
    readTime: "11 min read",
  },
  {
    id: 10,
    blogName: "Full Stack Army",
    blogImage:
      "https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fGJsb2dzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    authorLogo:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR02rOHqiCwMQ4UUIhlRuTe73lbViLpyVzKQ3mkJlfATw&s",
    authorName: "Stack Learner",
    blogCategory: "Programming",
    blogDate: "9 April, 2022",
    readTime: "12 min read",
  },
  {
    id: 11,
    blogName: "Know About Node JS",
    blogImage:
      "https://images.unsplash.com/photo-1502945015378-0e284ca1a5be?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzV8fGJsb2dzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    authorLogo: "https://avatars.githubusercontent.com/u/73503432?v=4",
    authorName: "Learn with sumit",
    blogCategory: "Web Development",
    blogDate: "08 Feb, 2022",
    readTime: "11 min read",
  },
  {
    id: 12,
    blogName: "All About Venila JS",
    blogImage:
      "https://images.unsplash.com/photo-1483058712412-4245e9b90334?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTZ8fGJsb2dzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    authorLogo:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR02rOHqiCwMQ4UUIhlRuTe73lbViLpyVzKQ3mkJlfATw&s",
    authorName: "Stack Learner",
    blogCategory: "Programming",
    blogDate: "18 Feb, 2022",
    readTime: "12 min read",
  },
];

export default initialState;
